export default __webpack_public_path__ + "static/media/katika-world-map.ad76b48a.png";